import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const ChartWrapper = styled.div<{ leftWidth: number; isEmpty: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.magenta500};
  padding: 8px 6px;
  border-radius: 2px;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  span {
    color: ${({ theme }) => theme.colors.white100};
    z-index: 1;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.magenta600};
  }

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      background-color: ${({ theme }) => theme.colors.gray200};

      &:hover {
        background-color: ${({ theme }) => theme.colors.gray200};
      }
    `}

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const EmptyMessage = styled.div`
  position: absolute;
  top: 8px;
  left: 0;
  background-color: ${({ theme }) => theme.colors.gray200};
  border-radius: 2px;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.gray600};
  z-index: 2;
  ${getFontStyle('midium150_C1')};
`;

export const Bar = styled.div<{ leftWidth: number }>`
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.greypurple300};
  width: ${({ leftWidth }) => leftWidth}%;
  height: 100%;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.greypurple400};
  }
`;
